export default (props, e) => {

	const fulltextId = '#fulltext';
	const fulltextActiveClass = 'header__fulltext--active';
	const fulltextFrm = document.querySelector('[name="frm.query"]');
	const fulltextTarget = document.querySelector(fulltextId);

	if (fulltextTarget && window.innerWidth > 768) {
		if (!fulltextTarget.classList.contains(fulltextActiveClass)) {
			e.preventDefault();
			fulltextTarget.classList.add(fulltextActiveClass);
			fulltextFrm.focus();
		} else {
			if (fulltextFrm.value.length === 0) {
				e.preventDefault();
				fulltextTarget.classList.remove(fulltextActiveClass);
			}
		}
	}
};




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/openFulltext.js